const savePricingDetailsToast = (state = null, action) => {
  if (action.type === "SET_SAVE_PRICING_DETAILS_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_SAVE_PRICING_DETAILS_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default savePricingDetailsToast;
